export enum Timespan {
  FiveMinutes = 'FIVE_MINUTES',
  Hour = 'HOUR',
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
  Year = 'YEAR'
}
